import React from 'react';

import { ListItemText, NavGroupL2, NavGroupTitleL2, NavItemL2 } from '@mesh.ai/rabbit';
import { L3_PATHS } from 'Deer/constants/routes';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { NavLink } from 'react-router-dom';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { modifyString, StringModifier } from 'constants/copyHelpers';

import { L2_MODULES_COMPANY } from '../../constants';

const activeClassName = 'active-L2';

// TODO: this will probably be moved to redux once the new API for navigation is ready
export const getApplicableL2CompanyModules = (customGoalName: string) => {
  const L2_MODULES_WITH_CUSTOM_GOAL_NAME = L2_MODULES_COMPANY;

  L2_MODULES_WITH_CUSTOM_GOAL_NAME.goals.label = modifyString(customGoalName, StringModifier.PLURAL_TITLE_CASE);

  L2_MODULES_WITH_CUSTOM_GOAL_NAME.review.value = checkIntentLandingPagesFeatureEnabled()
    ? L3_PATHS.company.review.completionStatus
    : L3_PATHS.company.review.manage;

  return Object.values(L2_MODULES_WITH_CUSTOM_GOAL_NAME)
    .filter((module) => module.checkModuleIsEnabled())
    .sort((a, b) => a.order - b.order);
};

export const CompanyModules = () => {
  const { moduleName } = useOrganisationSettings();
  const { l2Module } = useRouteToNavLevels();

  const applicableL2Modules = getApplicableL2CompanyModules(moduleName);

  return applicableL2Modules.length > 0 ? (
    <NavGroupL2>
      <NavGroupTitleL2>PORTFOLIO</NavGroupTitleL2>
      {applicableL2Modules.map((module) => (
        <NavLink
          key={module.value}
          to={module.value}
          activeClassName={activeClassName}
          isActive={() => l2Module === module.key}
        >
          <NavItemL2>
            <ListItemText title={module.label} />
          </NavItemL2>
        </NavLink>
      ))}
    </NavGroupL2>
  ) : null;
};
